import { Grid, useTheme } from '@mui/material';
import SuiBox from '@upheal/design-system/components/legacy/Sui/SuiBox';
import SuiTypography from '@upheal/design-system/components/legacy/Sui/SuiTypography';
import PageLayout from '@upheal/shared/components/shared/LayoutContainers/PageLayout';

function Error404() {
    const theme = useTheme();
    const { d1, d3, d4, d5 } = theme.typography;

    return (
        <PageLayout>
            <SuiBox height="100vh">
                <Grid
                    container
                    spacing={3}
                    justifyContent="center"
                    alignItems="center"
                    sx={{ height: '100%' }}
                >
                    <Grid
                        container
                        alignItems="center"
                        size={{
                            xs: 11,
                            sm: 9,
                        }}
                    >
                        <Grid
                            size={{
                                xs: 12,
                                lg: 12,
                            }}
                        >
                            <SuiBox
                                fontSize={{
                                    xs: d5.fontSize,
                                    sm: d4.fontSize,
                                    md: d3.fontSize,
                                    lg: d1.fontSize,
                                }}
                                lineHeight={1.2}
                            >
                                <SuiTypography
                                    variant="inherit"
                                    color="error"
                                    textGradient
                                    fontWeight="bold"
                                >
                                    Error 404
                                </SuiTypography>
                            </SuiBox>
                            <SuiTypography
                                variant="h2"
                                color="dark"
                                textGradient
                                fontWeight="bold"
                            >
                                Page not found
                            </SuiTypography>
                            <SuiBox mt={1} mb={2}>
                                <SuiTypography variant="body1" color="body">
                                    Please check you have a correct link and try
                                    again.
                                </SuiTypography>
                            </SuiBox>
                        </Grid>
                    </Grid>
                </Grid>
            </SuiBox>
        </PageLayout>
    );
}

export default Error404;
